import fetch from 'utils/fetch'

export const addApp = params => {
    return fetch({
        url: '/apply/app-apply',
        data: params,
        method: 'POST',
    })
}
